import React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { MEDIA_BREAKPOINTS } from '../../mediaQueries.const';
import { BlockWidths } from '../components/pageLayouts/BlockTypes.utils';
import { AdditionalStyleSheet } from '../components.utils';
import { createBlockStyle } from '../articleComponents/blockMutualStyle';

interface MMPlayerPlaceHolderProps {
  smallAndMediumScreens?: boolean;
  largeScreen?: boolean;
  defaultBlocksWidths?: BlockWidths;
  additionalStyle?: AdditionalStyleSheet;
}

const videoRatio = {
  x: 16,
  y: 9,
};

const getDefaultBlocksWidthsStyle = (defaultBlocksWidths: BlockWidths) => {
  return StyleSheet.create({
    style: {
      ...createBlockStyle(defaultBlocksWidths),
    },
  }).style;
};

const createWrapperStyle = () => StyleSheet.create({
  style: {
    backgroundColor: 'transparent',
    position: 'relative',
    overflow: 'hidden',
    boxSizing: 'border-box',
    minWidth: '0%',
    [MEDIA_BREAKPOINTS.large]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`,
    },
    [MEDIA_BREAKPOINTS.medium]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`,
    },
    [MEDIA_BREAKPOINTS.small]: {
      paddingTop: `calc(100% / (${videoRatio.x / videoRatio.y}))`,
    },
  },
}).style;

const createPlaceholderStyle = () => StyleSheet.create({
  style: {
    position: 'absolute',
    top: '0',
    left: '0',
    bottom: '0',
    minWidth: '100%',
    minHeight: '100%',
    maxWidth: '100%',
    maxHeight: '100%',
    marginTop: '-16px',
  },
}).style;

const createDisplayStyleByScreenSize = (smallAndMediumScreens: boolean, largeScreen: boolean) => StyleSheet.create({
  style: {
    [MEDIA_BREAKPOINTS.large]: {
      display: largeScreen ? 'block' : 'none',
    },
    [MEDIA_BREAKPOINTS.medium]: {
      display: smallAndMediumScreens ? 'block' : 'none',
    },
    [MEDIA_BREAKPOINTS.small]: {
      display: smallAndMediumScreens ? 'block' : 'none',
    },
  },
}).style;

const baseID = 'mm-player-placeholder';
export const MMPlayerPlaceHolder: React.FunctionComponent<MMPlayerPlaceHolderProps> = props => {
  const { smallAndMediumScreens = false, largeScreen = false, additionalStyle, defaultBlocksWidths } = props;
  const wrapperStyle = createWrapperStyle();
  const placeholderStyle = createPlaceholderStyle();
  const displayStyle = createDisplayStyleByScreenSize(smallAndMediumScreens, largeScreen);
  const id = smallAndMediumScreens ? `${baseID}-smallAndMedium-screens` : `${baseID}-large-screen`;
  return (!smallAndMediumScreens && !largeScreen) || (smallAndMediumScreens && largeScreen) ? null : (
    <figure className={css(defaultBlocksWidths ? getDefaultBlocksWidthsStyle(defaultBlocksWidths) : null, displayStyle)}>
      <div className={css(wrapperStyle, additionalStyle ? additionalStyle.style : null, displayStyle)}>
        <div id={id} className={css(placeholderStyle, displayStyle)} />
      </div>
    </figure>
  );
};
